import Vue from 'vue';
import helper from '@/libs/forms';


const propertyFields = () => {
  const propertyTypes = [
    { id: 'comm', name: 'Commercial' },
    { id: 'condo', name: 'Condo' },
    { id: 'duplex', name: 'Duplex' },
    { id: 'triplex', name: 'Triplex' },
    { id: 'land', name: 'Land' },
    { id: 'manufactured', name: 'Manufactured' },
    { id: 'multifamily', name: 'Multifamily (>4 units)' },
    { id: 'mixed', name: 'Mixed-Use' },
    { id: 'quad', name: 'Quad' },
    { id: 'sfr', name: 'SFR' },
    { id: 'other', name: 'Other' },
  ];

  const loanField = helper.boolRadio(
    'Do you have a loan on this property?',
    'loan',
    true,
    12,
    null,
  );
  loanField.onChanged = (model, newVal) => {
    if (!newVal) {
      Vue.delete(model, 'holder');
    }
  };

  return [
    helper.simpleSelect(
      'Type of Property',
      'propertyType',
      true,
      propertyTypes,
      null,
      6,
    ),
    helper.address('Address', null, 'address', true, 6),
    helper.date('Date Purchased', null, 'date', true, 6, null, false, true),
    helper.currency('Original Cost', 'originalCost', true, 6),
    helper.currency('Present Market Value', 'presentValue', true, 6),
    loanField,
  ];
};


const mortgageFields = () => {
  const mortgageFrequency = [
    { id: 'monthly', name: 'Monthly' },
    { id: 'annual', name: 'Annually' },
  ];
  const mortgageStatus = [
    { id: 'current', name: 'Current' },
    { id: 'delinquent', name: 'Delinquent' },
    { id: 'foreclosure', name: 'Foreclosure' },
  ];

  return [
    helper.simpleInput('text', 'Holder Name', null, 'holder.name', true, 6),
    helper.address('Holder Address', null, 'holder.address', true, 6),
    helper.simpleInput('text', 'Account Number', null, 'holder.account', false, 6),
    helper.currency('Balance', 'holder.balance', true, 6),
    helper.simpleSelect('Frequency', 'holder.frequency', true, mortgageFrequency, null, 6),
    helper.currency('Amount of Payment', 'holder.payment', true, 6),
    helper.simpleSelect('Status', 'holder.status', true, mortgageStatus, null, 6),
  ];
};


export default {
  property: {
    schema: { fields: propertyFields() },
    formOptions: helper.options('financial-realEstate-property-', true),
  },
  mortgage: {
    schema: { fields: mortgageFields() },
    formOptions: helper.options('financial-asset-', true),
  },
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/tabs/financial/assets/schemas/realEstate.js